import { ToastrService } from 'ngx-toastr';
import { Component } from '@angular/core';
import { WebSiteUsersService } from '@app/services/webSiteUsers/webSiteUsers.service';
import { PdvService } from '@app/services/pdv/pdv.service';
import { localStorageService } from '@app/services/localStorage/localStorage.service';
import { Router } from '@angular/router';
import { AuthService } from '@app/modules/angular-6-social-login-master';

@Component({
     
    selector: 'checkout-authentification',
    templateUrl: 'checkout-authentification.component.html',
    styleUrls: ['checkout-authentification.component.scss'],
    providers:[AuthService]
})
export class CheckoutAuthentificationComponent {
    user: any = {
        lastname: "",
        phone: "",
        email: "",
        password: "",
        confirmePassword: "",
        pdv: ""
    }
    loader: boolean = false;
    step = 1;
    socialProvider = "";
    idToken = "";
    phone = "";
    signinstep = 1;
    constructor(
        private toastr: ToastrService,
        private webSiteUsersService: WebSiteUsersService,
        private pdvService: PdvService,
        private localStorage:localStorageService,
        private router:Router,
        public OAuth: AuthService
    ) {
        this.user.pdv = this.pdvService.idPdv;
    }

    signup() {
        if (this.user.lastname.trim() == '' || this.user.email.trim() == '' || this.user.phone.trim() == '' || this.user.password.trim() == '' || this.user.confirmePassword.trim() == '') {
            this.toastr.error('Merci de remplir tous les champs', 'Attention !');
        } else {
            if (!(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.user.email))) {
                this.toastr.error('Merci de saisir une adresse email valide', 'Attention !');
            } else {
                if (!this.user.phone.match(/^\d{10}$/)) {
                    this.toastr.error('Merci de saisir un numèro valide', 'Attention !');
                } else {
                    if (this.user.password.trim().length < 8) {
                        this.toastr.error('mot de passe invalide minimum 8 caractères ', 'Attention !');
                    } else {
                        if (this.user.password !== this.user.confirmePassword) {
                            this.toastr.error('les mots de passe saisis ne sont pas identiques', 'Attention !');
                        } else {
                            this.loader = true;
                            this.webSiteUsersService.addCustomer(this.user).subscribe(
                                (data: any) => {
                                    this.localStorage.setItem({key:'token', value:data.token});
                                    this.webSiteUsersService.listener.next(true);
                                    this.loader = false;
                                    this.router.navigate(['/checkout/confirmation']);
                                    this.toastr.success('Merci de consulter votre boite email pour valider votre inscription.', 'Success !');
                                }, (err: any) => {
                                    this.loader = false;
                                    if (err.status == 409) {
                                        this.toastr.error('Ce compte existe déja', 'Attention !');
                                    }else{
                                        this.toastr.error('Erreur '+err.status, 'Erreur !');
                                    }
                                }
                            )
                        }
                    }
                }
            }
        }
    }

    login() {
        if (!(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.user.email))) {
            this.toastr.error('Merci de saisir une adresse email valide', 'Attention !');
        } else {
            if (this.user.password.trim().length < 8) {
                this.toastr.error('Merci de saisir un mot de passe valide (8 characteres)', 'Attention !');
            } else {
                this.loader = true;
                this.webSiteUsersService.login({ email: this.user.email, password: this.user.password, pdv: this.user.pdv }).subscribe(
                    (data: any) => {
                        this.localStorage.setItem({key:'token', value:data.token});
                        this.webSiteUsersService.listener.next(true);
                        this.loader = false;
                        this.router.navigate(['/checkout/confirmation']);
                    }, (err: any) => {
                        this.loader = false;
                        if (err.status == 400) {
                            this.toastr.error("l'adresse email ou mot de passe incorrect", 'Attention !');
                        }else{
                            this.toastr.error('Erreur '+err.status, 'Erreur !');
                        }
                    }
                )
            }
        }
    }

    sendPassword() {
        if (!(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.user.email))) {
            this.toastr.error('Merci de saisir une adresse email valide', 'Attention !');
        } else {
            this.loader = true;
            this.webSiteUsersService.forgetPassword(this.user.email).subscribe(
                (data:any) => {
                   this.loader = false;
                    if (data.success) {
                        this.toastr.success('Merci de consulter votre boite email pour obtenir votre mot de passe');
                        this.step=1;
                    } else {
                        this.toastr.error('Aucun compte trouvé');
                    }
                },
                (err)=>{
                    this.loader = false;
                }
            )
        }
    }

    signIn(provider) {
        this.OAuth.signIn(provider).then(socialusers => {
            console.log(socialusers)
            this.socialProvider = provider;
            this.idToken = (provider=='facebook')?socialusers.token:socialusers.idToken;
            let clientId = (provider=='facebook')?PdvService.facebookId:PdvService.googleId;
            this.signInWithSocial({ clientId, provider, idToken: this.idToken })
        });
    }

    signInWithSocial(params) {
        this.webSiteUsersService.signInWithSocial(params).subscribe(
            (data: any) => {
                this.localStorage.setItem({ key: 'token', value: data.token });
                this.webSiteUsersService.listener.next(true);
                this.loader = false;
                this.router.navigate(['/checkout/confirmation']);
            },
            (err: any) => {
                if (err.status == 400 && err.error.code == 1) {
                    this.signinstep = 2;
                } else {
                    this.toastr.error('Code : ' + err.status, 'Erreur Serveur');
                }
            }
        )
    }


    back() {
        this.signinstep = 1;
    }

    valide() {
        if (!this.phone.match(/^\d{10}$/)) {
            this.toastr.error('Merci de saisir un numèro valide', 'Attention !');
            this.loader = false;
        } else {
            let clientId = (this.socialProvider=='facebook')?PdvService.facebookId:PdvService.googleId;
            this.signInWithSocial({ clientId, provider: this.socialProvider, idToken: this.idToken, phone: this.phone })
        }
    }
}
